import { services } from '@/utils'

import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderTitle(h) {
  let icon = 'error_outline'
  let color = 'error'
  let activeKey = 'notActive'
  if (this.value.isActive) {
    icon = 'check_circle_outline'
    color = 'success'
    activeKey = 'active'
  }

  return h(
    sticker,
    {
      props: {
        value: this.value,
        label: `${this.getTranslate(`${services.messageRuleGroups}.labels.title`)}`,
        icon,
        color,
        iconTooltip: this.getTranslate(`${services.messageRuleGroups}.tooltips.${activeKey}`),
        service: services.messageRuleGroups,
        width: 'fit-content'
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item': true,
        [`${services.messageRuleGroups}-panel`]: true
      }
    },
    [
      renderTitle.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
